import React from 'react'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import ProfileContent from '../../../components/comment/profile/profileContent';
import NetAmount from './amount';
import AddedDetail from './addeddetail';
import AddNewDetail from './addnewdetail';



const netbankingContent = () => {
  return (
    <div className=" add-net-banking-wrap">
    <Container className="main-account-content ">
      <Row className="main-content pt-4 pb-5">
        <Col lg={3} className="content-left">
          <ProfileContent />
        </Col>

        <Col lg={9} className="content-right  " >
          <div className='verification-wrap'>
            <NetAmount />
            <AddedDetail />
            <AddNewDetail />
         </div>
        </Col>
      </Row>
    </Container>
  </div>
  )
}

export default netbankingContent